<app-lfsa-card *ngIf="!loading" [innTemplate]="enviarTemplate" [titulo]="'Sistema De Conciliación Bancaria'">
</app-lfsa-card>
<ng-template #enviarTemplate>
  <form [formGroup]="formulario" class="form-group" novalidate>

    <div class="row col 12">
      <div class="form-group col-md-4">
        <app-lfsa-combo-box (change)="BancoEmpresa($event.target)" [claseLabel]="'letrasDanger'" [comboBox]="cmbEmpresa"
                            [control]="this.formulario.get('idEmpresa')" [idOpcion]="'idEmpresa'"
                            [id]="'idEmpresa'"
                            [label]="'Sociedad*'" [opcion]="'dscaEmpresa'" formControlName="idEmpresa">
        </app-lfsa-combo-box>
      </div>
      <div class="form-group col-md-4">
        <app-lfsa-combo-box (change)="cuentaBanco($event.target)" [claseLabel]="'letrasDanger'" [comboBox]="cmbBanco"
                            [control]="this.formulario.get('idBanco')" [idOpcion]="'idBanco'" [id]="'idBanco'"
                            [label]="'Bancos*'" [opcion]="'dscaBanco'"
                            formControlName="idBanco"></app-lfsa-combo-box>
      </div>

      <div class="form-group col-md-4">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('cuenta')" [id]="'cuenta'"
                        [isReadOnly]="bloquearCampo" [label]="'N° Cuenta*'" [type]="'number'"
                        formControlName="cuenta">
        </app-lfsa-input>
      </div>

    </div>
    <div class="row col 12">
      <div class="form-group col-md-4">
        <!-- <label for="fechaExtracto">Fecha Extracto</label>
        <input type="date" class="form-control" id="fechaExtracto" formControlName="fechaExtracto"
            placeholder="Fecha" /> -->
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('fechaExtracto')"
                        [id]="'fechaExtracto'" [label]="'Fecha de carga cabecera*'" [type]="'date'"
                        formControlName="fechaExtracto">
        </app-lfsa-input>
      </div>
    </div>
    <div class="col-12">
      <form (ngSubmit)="onSubmit()" [formGroup]="formulario">
        <div class="row">
          <div [hidden]="habilitaCabec" class="col-6">
            <div class="form-group animated fadeInRight">
              <label class="letrasDanger" for="csvInput">Cabecera .csv*</label>
              <input #fileInput (change)="onFileSelect($event)" accept=".csv"
                     class="form-control-file" id="csvInputCab" type="file"/>
            </div>
          </div>
          <div [hidden]="habilitaDeta" class="col-6 animated fadeInRight">
            <div class="form-group">
              <label class="letrasDanger" for="csvInput">Detalle .csv*</label>
              <input #fileInput (change)="onFileSelect($event)" accept=".csv"
                     class="form-control-file" id="csvInputCuerp" type="file"/>
            </div>
          </div>
        </div>
        <br>
        <div *ngIf="formulario.invalid ||  validationCsv" class="row">
          <div class="form-group col-12">
            <div class="alert alert-danger animated fadeInRight" role="alert">
              <h5><b> El botón se activará cuando complete toda la información requerida que está marcada con (*) </b>
              </h5>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <button [disabled]="formulario.invalid || validationCsv"
                    class="{{DAT_BTNCSS.primary}}">{{ DATA_BTNS.procesar }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </form>
</ng-template>
<div *ngIf="loading" class="containerLoader">
  <div class="item-1"></div>
  <div class="item-2"></div>
  <div class="item-3"></div>
  <div class="item-4"></div>
  <div class="item-5"></div>
</div>
<!-- <div class="col-12">
    <div class="animated fadeInRight" *ngIf="!loading">

        <div class="card ">
            <div class="card-header">
                <strong>Sistema De Conciliación Bancaria</strong>
            </div>
            <div class="card-body">
                <form [formGroup]="formulario" novalidate class="form-group">

                    <div class="row col 12">
                        <div class="form-group col-md-4">
                            <app-lfsa-combo-box [opcion]="'dscaEmpresa'" [idOpcion]="'idEmpresa'" [comboBox]="cmbEmpresa"
                                formControlName="idEmpresa" [control]="this.formulario.get('idEmpresa')"
                                [label]="'Sociedad'" [id]="'idEmpresa'" (change)="BancoEmpresa($event.target)">
                            </app-lfsa-combo-box>
                        </div>
                        <div class="form-group col-md-4">
                            <app-lfsa-combo-box [opcion]="'dscaBanco'" [idOpcion]="'idBanco'" [comboBox]="cmbBanco"
                                formControlName="idBanco" [control]="this.formulario.get('idBanco')" [label]="'Bancos'"
                                [id]="'idBanco'" (change)="cuentaBanco($event.target)"></app-lfsa-combo-box>
                        </div>

                        <div class="form-group col-md-4">
                            <app-lfsa-input [label]="'N° Cuenta'" [isReadOnly]="bloquearCampo" [type]="'number'"
                                [id]="'cuenta'" formControlName="cuenta" [control]="this.formulario.get('cuenta')">
                            </app-lfsa-input>
                        </div>

                    </div>
                    <div class="row col 12">
                        <div class="form-group col-md-4">
                            <label for="fechaExtracto">Fecha Extracto</label>
                            <input type="date" class="form-control" id="fechaExtracto" formControlName="fechaExtracto"
                                placeholder="Fecha" />
                        </div>
                    </div>
                    <div class="col-12">
                        <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
                            <div class="row">
                                <div class="col-6" [hidden]="habilitaCabec">
                                    <div class="form-group animated fadeInRight">
                                        <label for="csvInput">Cabecera .csv</label>
                                        <input type="file" class="form-control-file" id="csvInputCab"
                                            (change)="onFileSelect($event)" #fileInput accept=".csv" />
                                    </div>
                                </div>
                                <div class="col-6 animated fadeInRight" [hidden]="habilitaDeta">
                                    <div class="form-group">
                                        <label for="csvInput">Detalle .csv</label>
                                        <input type="file" class="form-control-file" id="csvInputCuerp"
                                            (change)="onFileSelect($event)" #fileInput accept=".csv" />
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-md-4">
                                    <button class="{{DAT_BTNCSS.primary}}"
                                        [disabled]="formulario.invalid || validationCsv">{{DATA_BTNS.procesar}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </form>
                <br>

            </div>
        </div>
    </div>
    <div class="containerLoader" *ngIf="loading">
        <div class="item-1"></div>
        <div class="item-2"></div>
        <div class="item-3"></div>
        <div class="item-4"></div>
        <div class="item-5"></div>
    </div>
</div> -->
